import { render } from "./NoteMessage.vue?vue&type=template&id=ae91a2d2&scoped=true&ts=true"
import script from "./NoteMessage.vue?vue&type=script&lang=ts"
export * from "./NoteMessage.vue?vue&type=script&lang=ts"

import "./NoteMessage.vue?vue&type=style&index=0&id=ae91a2d2&lang=scss&scoped=true"
import "./NoteMessage.vue?vue&type=style&index=1&id=ae91a2d2&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae91a2d2"]])

export default __exports__